import { render } from "./zhuguanyaoshi-news.vue?vue&type=template&id=6a2ea181&scoped=true"
import script from "./zhuguanyaoshi-news.vue?vue&type=script&lang=js"
export * from "./zhuguanyaoshi-news.vue?vue&type=script&lang=js"

import "./zhuguanyaoshi-news.vue?vue&type=style&index=0&id=6a2ea181&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2ea181"]])

export default __exports__